import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'labor-remuneration';

export const state = {
    orgId: UserPersistence.getOrgId(),
    isShow: true,
    laborRemunerationDetails: '',
    laborRemunerationId: '',
    abId: '',
    accountInfo: {},
    routerUrl: '',
    isView: false,
    disable: false,
    buttonType: '',
    params: null,
    billCode: ''
}
export const mutations = {
    setLaborRemunerationDetails(state, data) {
        state.laborRemunerationDetails = data
    },
    setLaborRemunerationIsShow(state, flag) {
        state.isShow = flag
    },
    setOrgId(state, id) {
        state.orgId = id
    },
    setLaborRemunerationId(state, data) {
        state.laborRemunerationId = data.id
        state.abId = data.abId
    },
    setAccountInfo(state, data) {
        state.accountInfo = data
    },
    setLaborRemunerationRouterUrl(state, url) {
        state.routerUrl = url
    },
    setLaborRemunerationIsView(state, flag) {
        state.isView = flag
    },
    setLaborRemunerationDisable(state, flag) {
        state.disable = flag
    },
    setButtonType(state, type) {
        state.buttonType = type
    },

    setParams(state, data) {
        state.params = data
    },
    setBillCode(state, code) {
        state.billCode = code
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/labor-remuneration/index.js